export const FlipsterUrl = 'https://flipster.io';
